import React from "react";
import styles from "./LoginPage.module.css";
import * as Yup from "yup";
import { ERROR_MESSAGE } from "shared/Constants";
import { FastField, Form, Formik } from "formik";

import InputFiled from "shared/components/InputField";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { useDispatch } from "react-redux";
import { fetchLoginRequest } from "redux/ActionCreators/AuthCreators";

const LoginPage = () => {
  const dispatch = useDispatch();

  const handleSubmit = (data) => {
    dispatch(fetchLoginRequest(data));
  };
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <Typography variant="h4" gutterBottom>
          Đăng nhập
        </Typography>
      </div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => {
          return (
            <Form className={styles.content}>
              <FastField
                name="username"
                component={InputFiled}
                label="Username"
                className={styles.item}
              />
              <FastField
                name="password"
                component={InputFiled}
                label="password"
              />
              <Button
                variant="contained"
                color="secondary"
                size="large"
                type="submit"
                className={styles.btn_submit}
              >
                Đăng nhập
              </Button>
            </Form>
          );
        }}
      </Formik>
      <Typography
        variant="caption"
        display="block"
        gutterBottom
        style={{ marginTop: "20px" }}
      >
        Bạn chưa có tài khoản! Đăng ký <a href="#">tại đây</a>
      </Typography>
    </div>
  );
};

const initialValues = {
  username: "",
  password: "",
};

const validationSchema = Yup.object().shape({
  username: Yup.string().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
  password: Yup.string().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
});

export default LoginPage;
